import first from 'lodash/first';

import {
  getIdFrom,
  getUuidFrom
} from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import {
  QUEUE_OVERLAY_CONTENT_ITEM_FOR_DELETE,
  QUEUE_DOWNLOADABLE_CONTENT_ITEM_FOR_DELETE
} from 'zoomforth_codesbane_editor/action_types.js';

import { 
  getAppActionForUrl,
  getTemporaryFroalaLinkData,
  getCurrentlyEditingSection,
  getCurrentlyEditingContentItems,
  getCurrentFroalaLinkEditorInstance,
  getOverlayContentItemsToDelete,
  getDownloadableContentItemsToDelete
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  deleteContentItems
} from 'zoomforth_codesbane_editor/action_creators/content.js';

import {
  setEditingTileCaption
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import {
  getContentItemByUuid,
  getSubpageForContent,
  getSectionSingletonContentItem,
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  goToContent,
  setCurrentSubpageId
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import {
  editTargetForInternalLink
} from 'zoomforth_codesbane_editor/action_creators/internal_link_target.js';

import {
  advancedLinkEditorPlugin,
  BUTTON_TYPE_PRIMARY
} from 'zoomforth_codesbane_editor/component_lib/froala_plugins/advanced_link_editor.plugin.jsx';

import {
  getIsChoosingContentItem,
} from 'zoomforth_codesbane_editor/reducers/index.js';


export const openAdvancedSidebarLinkEditor = ({ href, text, target, isButton, buttonType })=>
  (dispatch, getState)=> {
    const appAction = getAppActionForUrl(getState(), href, target);
    const currentSection = getCurrentlyEditingSection(getState());
    const currentSectionId = currentSection ? getIdFrom(currentSection) : null;
    const currentContentItem = first(getCurrentlyEditingContentItems(getState()));

    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);
    const editorHTMLWithMarkers = plugin.getHtml(true);

    var currentContentUuid;
    if (currentContentItem) {
      currentContentUuid = getUuidFrom(currentContentItem);
    } else if (currentSectionId) {
      const sectionSingletonContentItem = getSectionSingletonContentItem(getState(), currentSectionId);
      currentContentUuid = sectionSingletonContentItem ? getUuidFrom(sectionSingletonContentItem) : null;
    } else {
      currentContentUuid = null;
    }

    dispatch(setTemporaryFroalaLinkData({
      appAction,
      text,
      isButton,
      buttonType,
      editorHTMLWithMarkers,
      sectionId: currentSectionId,
      contentUuid: currentContentUuid
    }));
  };


export const setTemporaryFroalaLinkData = (temporaryFroalaLinkData)=> {
  return {
    type: 'SET_TEMPORARY_FROALA_LINK_DATA',
    temporaryFroalaLinkData
  };
};


export const updateTemporaryFroalaLinkData = (newData = {})=>
  (dispatch, getState)=> {
    const temporaryFroalaLinkData = getTemporaryFroalaLinkData(getState()) || {};

    dispatch(setTemporaryFroalaLinkData({
      ...temporaryFroalaLinkData,
      ...newData
    }));
  };


export const editTemporaryFroalaLinkDataTargetForInternalLink = ()=>
  (dispatch, getState)=> {
    const temporaryFroalaLinkData = getTemporaryFroalaLinkData(getState());
    const { subpageId, sectionId, contentUuid } = temporaryFroalaLinkData.appAction;

    dispatch(editTargetForInternalLink(subpageId, sectionId, contentUuid));
  };


export const setCurrentSubpageToFroalaContent = ()=>
  (dispatch, getState)=> {
    const temporaryFroalaLinkData = getTemporaryFroalaLinkData(getState());
    const { contentUuid } = temporaryFroalaLinkData;
    const contentItem = getContentItemByUuid(getState(), contentUuid);
    const subpage = getSubpageForContent(getState(), contentItem);

    dispatch(setCurrentSubpageId(subpage.id));
    dispatch(goToContent(contentItem));
  };


export const deleteLinkFromEditor = ()=>
  (dispatch, getState)=> {
    const { editorHTMLWithMarkers } = getTemporaryFroalaLinkData(getState());
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);

    plugin.removeLinkInEditor(editorHTMLWithMarkers);

    dispatch(setTemporaryFroalaLinkData(null));
  };


export const insertTemporaryFroalaLinkDataIntoEditor = ()=>
  (dispatch, getState)=> {
    const { appAction, isButton, buttonType, text, editorHTMLWithMarkers } = getTemporaryFroalaLinkData(getState());
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    
    // Check if editor instance exists before trying to use it
    if (currentFroalaLinkEditorInstance) {
      const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);
      plugin.saveLinkInEditor(editorHTMLWithMarkers, appAction, text, isButton, buttonType);
      plugin.finishEditing();
    }

    dispatch(flushOverlayContentItemsToDelete());
    dispatch(flushDownloadableContentItemsToDelete());
    dispatch(setTemporaryFroalaLinkData(null));

    dispatch(setEditingTileCaption(null));
  };


export const updateLinkTextInEditor = (text)=>
  (dispatch, getState)=> {
    const { appAction, isButton, buttonType, editorHTMLWithMarkers } = getTemporaryFroalaLinkData(getState());
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);

    plugin.updateSelectionInEditor(editorHTMLWithMarkers, appAction, text, isButton, buttonType);

    dispatch(updateTemporaryFroalaLinkData({
      text,
      editorHTMLWithMarkers: plugin.getHtml(true)
    }));
  };


export const updateLinkStyleInEditor = (isButton)=>
  (dispatch, getState)=> {
    const { appAction, text, buttonType, editorHTMLWithMarkers } = getTemporaryFroalaLinkData(getState());
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);

    const buttonTypeOrNull = isButton ? buttonType || BUTTON_TYPE_PRIMARY : null;

    plugin.updateSelectionInEditor(editorHTMLWithMarkers, appAction, text, isButton, buttonTypeOrNull);

    dispatch(updateTemporaryFroalaLinkData({
      isButton,
      buttonType: buttonTypeOrNull,
      editorHTMLWithMarkers: plugin.getHtml(true)
    }));
  };


export const updateButtonTypeInEditor = (buttonType)=>
  (dispatch, getState)=> {
    const { appAction, isButton, text, editorHTMLWithMarkers } = getTemporaryFroalaLinkData(getState());
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);

    plugin.updateSelectionInEditor(editorHTMLWithMarkers, appAction, text, isButton, buttonType);

    dispatch(updateTemporaryFroalaLinkData({
      buttonType,
      editorHTMLWithMarkers: plugin.getHtml(true)
    }));
  };


export const finishEditingFroalaLinkData = ()=>
  (dispatch, getState)=> {
    const currentFroalaLinkEditorInstance = getCurrentFroalaLinkEditorInstance(getState());
    
    // Check if editor instance exists before trying to finish editing
    if (currentFroalaLinkEditorInstance) {
      const plugin = advancedLinkEditorPlugin(currentFroalaLinkEditorInstance);
      plugin.finishEditing();
    }

    dispatch(flushOverlayContentItemsToDelete());
    dispatch(flushDownloadableContentItemsToDelete());
    dispatch(setTemporaryFroalaLinkData(null));

    dispatch(setEditingTileCaption(null));
  };


export const queueOverlayContentItemForDelete = (contentItem)=> {
  return { type: QUEUE_OVERLAY_CONTENT_ITEM_FOR_DELETE, contentItem };
};

export const queueDownloadableContentItemForDelete = (contentItem)=> {
  return { type: QUEUE_DOWNLOADABLE_CONTENT_ITEM_FOR_DELETE, contentItem };
};


export const flushOverlayContentItemsToDelete = ()=>
  (dispatch, getState)=> {
    // attempt to clean up after a session of editing an overlay. this is a
    // minor effort in fighting payload growth via abandonned overlay content
    // items. we cannot do anything about sections or tiles which have been
    // deleted where overlay content was created however we can manage a
    // deletion process when someone is actively editing their link.
    //
    // why do this flush against a queue rather than inline when a replace
    // happens?
    //
    // two reasons: the first is that we can catch things like changing the
    // link type. the second is that issuing a delete actually removes the
    // current Froala instance we are working on leading to us being unable to
    // write the final edited link anywhere. we avoid these types of operations
    // until they are done editing and thus maintain the current Froala
    // instance.
    const overlayContentItemsToDelete = getOverlayContentItemsToDelete(getState());

    dispatch(deleteContentItems(overlayContentItemsToDelete));
  };

export const flushDownloadableContentItemsToDelete = ()=>
  (dispatch, getState)=> {
    // attempt to clean up after a session of editing a downloadable asset. this is a
    // minor effort in fighting payload growth via abandonned overlay content
    // items. we cannot do anything about sections or tiles which have been
    // deleted where downloadable content was created however we can manage a
    // deletion process when someone is actively editing their link.
    //
    // why do this flush against a queue rather than inline when a replace
    // happens?
    //
    // two reasons: the first is that we can catch things like changing the
    // link type. the second is that issuing a delete actually removes the
    // current Froala instance we are working on leading to us being unable to
    // write the final edited link anywhere. we avoid these types of operations
    // until they are done editing and thus maintain the current Froala
    // instance.
    const downloadableContentItemsToDelete = getDownloadableContentItemsToDelete(getState());

    dispatch(deleteContentItems(downloadableContentItemsToDelete));
  };


export const setCurrentFroalaLinkEditorInstance = (editorInstance)=>
  (dispatch, getState)=> {
    const temporaryFroalaLinkData = getTemporaryFroalaLinkData(getState());

    // when an editor mounts we get a new editor instance. we want to save this
    // so we can use it with the plugin to trigger different events. this block
    // specifically ensures that, when editing an internal link on a different
    // subpage, we instantiate the new editor instance with the previous HTML.
    // this ensures that we don't lose the previous HTML when switching back to
    // the current working subpage.
    //
    // this is only run if we have saved temporary data hence when we have a
    // new editor instantiated from switching subpages.

    const isChoosingContentItem = getIsChoosingContentItem(getState())
    if (editorInstance && temporaryFroalaLinkData && !isChoosingContentItem) {
      const plugin = advancedLinkEditorPlugin(editorInstance);

      plugin.restorePreviousHtmlAndFocus(
        temporaryFroalaLinkData.editorHTMLWithMarkers
      );
    }

    if (!isChoosingContentItem) {
        dispatch({
            type: 'SET_CURRENT_FROALA_LINK_EDITOR_INSTANCE',
            editorInstance
        });
    }
  };
